import React, { useContext } from 'react';
import classNames from 'classnames';

import Modal from 'components/Modal';
import styles from 'components/packages/Bacon/Cards/TwoByThree/styles.module.scss';

import { BreakpointContext } from 'lib/ContextTypes';

import './styles.themed.scss';

const block = 'card-overlay';

/**
 * CardOverlay component renders an overlay for a card, supporting modal display on small breakpoints.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.activeOnHover
 * @param {{ border: string; container: string }} [props.additionalClasses={ border: '', container: '' }] - Additional CSS classes
 * @param {React.ReactNode} props.children - Content to render inside the overlay.
 * @param {boolean} [props.isActive=false] - Whether or not the CardOverlay should be active
 * @param {boolean} [props.useModal=false] - Displays content in modal on small breakpoints.
 */
export const CardOverlay = ({
  activeOnHover,
  additionalClasses = { border: '', container: '' },
  children,
  isActive = false,
  useModal = false,
}) => {
  const { isS: isSmallBreakpoint } = useContext(BreakpointContext);

  const {
    border: borderColorOverride,
    container: additionalContainerClasses,
  } = additionalClasses;

  const borderColor = borderColorOverride || null;

  const sharedClasses = [
    block,
    borderColor,
    additionalContainerClasses,
  ];

  if (isSmallBreakpoint) {
    return isActive && useModal
      ? (
        <Modal preventBackgroundScroll>
          <div
            className={classNames(
              sharedClasses,
              `${block}--modal`,
            )}
          >
            {children}
          </div>
        </Modal>
      )
      : null;
  }

  return (
    <div
      className={classNames(
        sharedClasses,
        `${block}--absolute`,
        {
          [styles.cardOverlayHover]: activeOnHover,
          active: isActive,
        },
      )}
      data-testid="cardOverlay"
    >
      {children}
    </div>
  );
};
